// import React from "react";

// const StatusTags = ({
//   tag = "Active", // Active, On hold, Rejected, Inactive, Unknown ,Submitted,Exit
//   size = "md", // xs, xs-sm, sm, md, lg, xl
//   variant = "contained", // contained, outlined, text
//   icon = false,
//   className = "",
// }) => {
//   const tagClasses = {
//     Active: {
//       contained: "bg-success-50  text-success",
//       outlined: "border-[1px] border-success text-success",
//       text: "text-success",
//     },

//     Submitted: {
//       contained: "bg-success-50  text-success",
//       outlined: "border-[1px] border-success text-success",
//       text: "text-success",
//     },
//     "On hold": {
//       contained: "bg-warning-100 text-warning",
//       outlined: "border-[1px] border-warning text-warning",
//       text: "text-warning",
//     },
//     Rejected: {
//       contained: "bg-danger-50 text-danger",
//       outlined: "border-[1px] border-danger text-danger",
//       text: "text-danger",
//     },
//     Inactive: {
//       contained: "bg-black text-white",
//       outlined: "border-[1px] border-black text-black",
//       text: "text-black",
//     },
//     Unknown: {
//       contained: "bg-gray-100 text-gray-400",
//       outlined: "border-[1px] border-gray-400 text-gray-400",
//       text: "text-gray-400",
//     },
//     Exit: {
//       contained: "bg-danger-50 text-danger",
//       outlined: "border-[1px] border-danger text-danger",
//       text: "text-danger",
//     },
//   };
//   // Move this after tagClasses definition
//   const statusType = Object.keys(tagClasses).includes(tag) ? tag : "Unknown";
//   const sizeStyles = {
//     xs: "text-[10px] leading-5 px-2.5",
//     "xs-sm": "text-[10px] leading-5 px-2.5",
//     sm: "text-[12px] leading-6 px-2.5",
//     md: "text-[14px] leading-7 px-4",
//     lg: "text-[16px] leading-8 px-4",
//     xl: "text-[18px] leading-9 px-4",
//   };

//   const dotSizeStyles = {
//     xs: "w-1 h-1",
//     "xs-sm": "w-1 h-1",
//     sm: "w-1 h-1",
//     md: "w-1.5 h-1.5",
//     lg: "w-2 h-2",
//     xl: "w-3 h-3",
//   };

//   const dotColorStyles = {
//     Active: "bg-success",
//     Submitted: "bg-success",
//     "On hold": "bg-warning",
//     Rejected: "bg-danger",
//     Inactive: "bg-warning",
//     Unknown: "bg-gray-400",
//     Exit: "bg-danger",
//   };

//   return (
//     <div className="inline-block">
//       <div
//         className={`rounded-md flex items-center gap-1 box-border ${
//           tagClasses[statusType][variant]
//         } ${sizeStyles[size] || sizeStyles.md} ${className}`}
//       >
//         {icon && (
//           <div
//             className={`rounded-full ${dotColorStyles[statusType]} ${dotSizeStyles[size]}`}
//           />
//         )}
//         {tag}
//       </div>
//     </div>
//   );
// };

// export default StatusTags;

import React from "react";

const StatusTags = ({
  tag = "Active", // Active, On hold, Rejected, Inactive, Unknown ,Submitted,Exit, Blocked
  size = "md", // xs, xs-sm, sm, md, lg, xl
  variant = "contained", // contained, outlined, text
  icon = false,
  className = "",
}) => {
  // DRY shared styles
  const tagStyles = {
    success: {
      contained: "bg-success-50 text-success",
      outlined: "border-[1px] border-success text-success",
      text: "text-success",
    },
    warning: {
      contained: "bg-warning-100 text-warning",
      outlined: "border-[1px] border-warning text-warning",
      text: "text-warning",
    },
    danger: {
      contained: "bg-danger-50 text-danger",
      outlined: "border-[1px] border-danger text-danger",
      text: "text-danger",
    },
    black: {
      contained: "bg-black text-white",
      outlined: "border-[1px] border-black text-black",
      text: "text-black",
    },
    gray: {
      contained: "bg-gray-100 text-gray-400",
      outlined: "border-[1px] border-gray-400 text-gray-400",
      text: "text-gray-400",
    },
    info: {
      contained: "bg-info-100 text-info-400",
      outlined: "border-[1px] border-info-400 text-info-400",
      text: "text-info-400",
    },
    draft: {
      contained: "bg-draft-100 text-draft-700",
      outlined: "border-[1px] border-draft-600 text-draft-600",
      text: "text-draft-600",
    },
    invoiced: {
      contained: "bg-invoiced-100 text-invoiced-700",
      outlined: "border-[1px] border-invoiced-500 text-invoiced-500",
      text: "text-invoiced-600",
    },
  };

  // Map tag names to their style categories
  const tagStyleMap = {
    Active: "success",
    Submitted: "info",
    Approved: "success",
    Draft: "draft",
    "On hold": "warning",
    Rejected: "danger",
    Exit: "danger",
    Inactive: "black",
    "Job Inactive": "gray",
    Invoiced: "invoiced",
    Unknown: "gray",
    Blocked: "danger",
    DNC: "danger",
    Success: "success",
    Failed: "danger",
    Initiated: "info",
    Skipped: "warning",
  };

  const dotColorMap = {
    Active: "bg-success",
    Submitted: "bg-info",
    Approved: "bg-success",
    Draft: "bg-draft",
    "On hold": "bg-warning",
    Rejected: "bg-danger",
    Blocked: "bg-danger",

    Exit: "bg-danger",
    Inactive: "bg-warning",
    "Job Inactive": "bg-gray-500",
    Invoiced: "bg-invoiced",
    Unknown: "bg-gray-400",
  };

  const statusType = tagStyleMap[tag] ? tag : "Unknown";
  const styleCategory = tagStyleMap[statusType];

  const sizeStyles = {
    xs: "text-[10px] leading-5 px-2.5",
    "xs-sm": "text-[10px] leading-5 px-2.5",
    sm: "text-[12px] leading-6 px-2.5",
    md: "text-[14px] leading-7 px-4",
    lg: "text-[16px] leading-8 px-4",
    xl: "text-[18px] leading-9 px-4",
  };

  const dotSizeStyles = {
    xs: "w-1 h-1",
    "xs-sm": "w-1 h-1",
    sm: "w-1 h-1",
    md: "w-1.5 h-1.5",
    lg: "w-2 h-2",
    xl: "w-3 h-3",
  };

  return (
    <div className="inline-block">
      <div
        className={`rounded-md flex items-center gap-1 box-border ${
          tagStyles[styleCategory][variant]
        } ${sizeStyles[size] || sizeStyles.md} ${className}`}
      >
        {icon && (
          <div
            className={`rounded-full ${dotColorMap[statusType]} ${dotSizeStyles[size]}`}
          />
        )}
        {tag}
      </div>
    </div>
  );
};

export default StatusTags;
